<template>
    <div class="ss-live-page">
        <banner-video :vm="contentBanner"></banner-video>
        <teach-method></teach-method>
        <service-support></service-support>
        <subject-intro></subject-intro>
        <quality></quality>
    </div>
</template>
<script>
import bannerVideo from './components/banner-video'
import teachMethod from './components/content/teach-method'
import subjectIntro from './components/subject-intro'
import serviceSupport from './components/content/service-support'
import quality from './components/content/quality'
import { contentBanner } from '@/const'
export default {
    data () {
        return {
            contentBanner: contentBanner
        }
    },
    components: { bannerVideo, teachMethod, serviceSupport, subjectIntro, quality }
}
</script>
<style lang="scss" scoped>

</style>
